import { render } from "./CompanyProfile.vue?vue&type=template&id=4f97289e&scoped=true&ts=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=ts"
export * from "./CompanyProfile.vue?vue&type=script&lang=ts"

import "./CompanyProfile.vue?vue&type=style&index=0&id=4f97289e&lang=css"
import "./CompanyProfile.vue?vue&type=style&index=1&id=4f97289e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f97289e"]])

export default __exports__